import * as React from 'react';
import { SessionNote, SubjectNote, TestNote } from 'webportalclient';
import { ModalSize } from '../../misc/components/modal';
import { NotesModal } from "../../misc/components/NotesModal";

export interface NotesPanelProps {
    header: string;
    notes: SessionNote[] | SubjectNote[] | TestNote[];
    isAddingNotesEnabled: boolean;
    showNotesCount?: boolean;
    errorStatus?: string | undefined;
    modalSize: ModalSize;
    onAddNote: (annotation: string) => void;
    onEditNote: (id: string, comment: string, annotation: string) => void;
    buttonDisabled: boolean;
}

export const NotesPanel = (props: NotesPanelProps) => {
    const [isModalVisibility, setIsModalVisibility] = React.useState(false);
    const [isAddingNewNote, setIsAddingNewNote] = React.useState(false);

    return (
        <>
            <div className="panel panel-default">
                <div className="panel-body">
                    <button disabled={props.buttonDisabled} className="btn btn-primary" onClick={() => setIsModalVisibility(true)} data-automationid="NotesButton">
                        {props.header}
                        {props.showNotesCount ? <>&nbsp;<span className="badge badge-info">{props.notes.length}</span></> : null}
                    </button>
                </div>
            </div>
            <NotesModal
                isVisible={isModalVisibility}
                header={props.header}
                isAddingNote={isAddingNewNote}
                notes={props.notes}
                errorStatus={props.errorStatus}
                modalSize={props.modalSize}
                onAdd={annotation => { setIsAddingNewNote(true); props.onAddNote(annotation); setIsAddingNewNote(false); }}
                onCloseModal={() => setIsModalVisibility(false)}
                onEdit={props.onEditNote}
                disabled={!props.isAddingNotesEnabled}
            />
        </>
    );
}

export default NotesPanel;
